window.addEventListener('load', function(){
    // obtain plugin
    var cc = initCookieConsent();

    // run plugin with your configuration
    cc.run({
        current_lang: 'it',
        autoclear_cookies: true,                   // default: false
        page_scripts: true,                        // default: false

        // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        auto_language: 'document',                 // default: null; could also be 'browser' or 'document'
        // autorun: true,                          // default: true
        // force_consent: false,                   // default: false
        // hide_from_bots: false,                  // default: false
        // remove_cookie_tables: false             // default: false
        // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
        // cookie_expiration: 182,                 // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        // cookie_path: '/',                       // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        // revision: 0,                            // default: 0

        onFirstAction: function(user_preferences, cookie){
            // callback triggered only once
        },

        onAccept: function (cookie) {
            // callback triggered on the first accept/reject action, and after each page load
            if(cc.allowedCategory('analytics')){
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
            }
            if(cc.allowedCategory('targeting')){
                fbq('consent', 'grant');
            }
        },

        onChange: function (cookie, changed_preferences) {
            // callback triggered when user changes preferences after consent has already been given
            if(cc.allowedCategory('analytics') === false){
                gtag('consent', 'update', {
                    'ad_storage': 'denied',
                    'analytics_storage': 'denied'
                });
            } else {
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
            }
            if(cc.allowedCategory('targeting') === false){
                fbq('consent', 'revoke');
            } else {
                fbq('consent', 'grant');
            }
        },

        gui_options: {
            consent_modal: {
                layout: 'cloud',               // box/cloud/bar
                position: 'bottom center',     // bottom/middle/top + left/right/center
                transition: 'slide',           // zoom/slide
                swap_buttons: false            // enable to invert buttons
            },
            settings_modal: {
                layout: 'box',                 // box/bar
                // position: 'left',           // left/right
                transition: 'slide'            // zoom/slide
            }
        },

        languages: {
            'it': {
                consent_modal: {
                    title: ' I Cookie rendono le cose migliori!',
                    description: 'Utilizziamo cookie e identificatori di prima o terza parte con il tuo consenso e/o nostro interesse legittimo, allo scopo di immagazzinare o accedere alle informazioni sul tuo dispositivo, per raccogliere dati personali degli utenti per sviluppare e migliorare prodotti, nonché per visualizzare e misurare pubblicità  nostra e/o di terzi e/o contenuti personalizzati basati sulla tua navigazione (ad esempio le pagine visitate).', //
                    primary_btn: {
                        text: 'Accetto tutti i Cookie',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Impostazioni',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Centro preferenze sulla privacy',
                    save_settings_btn: 'Salva le impostazioni',
                    accept_all_btn: 'Accetta tutti',
                    reject_all_btn: 'Rifiuta tutti',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Nome'},
                        {col2: 'Dominio'},
                        {col3: 'Scadenza'},
                        {col4: 'Tipo'}
                    ],
                    blocks: [
                        {
                            title: 'Opzioni Cookie',
                            description: 'Questo sito Web utilizza cookie essenziali per garantirne il corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. Quest\'ultimo sarà impostato solo previo consenso.'
                        }, {
                            title: 'Cookie strettamente necessari',
                            description: "Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati nei nostri sistemi. Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, come l'impostazione delle preferenze di privacy, l'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non funzioneranno. Questi cookie non archiviano informazioni personali.",
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: 'october_session',       // match all cookies starting with "_ga"
                                    col2: 'puntopiumahome.it',
                                    col3: 'Sessione',
                                    col4: 'HTTP - Conserva lo stato della sessione del visitatore tra le richieste di pagina.',
                                    is_regex: true
                                },
                            ],
                        }, {
                            title: 'Cookie di analisi e prestazione',
                            description: 'Questi cookie ci permettono di contare le visite e fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più e meno popolari e vedere come i visitatori si muovono intorno al sito. Tutte le informazioni raccolte dai cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non sapremo quando hai visitato il nostro sito.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: '^_ga',
                                    col2: 'puntopiumahome.it',
                                    col3: '2 anni',
                                    col4: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    is_regex: true
                                },
                                {
                                    col1: '_gid',
                                    col2: 'puntopiumahome.it',
                                    col3: '1 giorno',
                                    col4: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.',
                                },
                                {
                                    col1: '^_gat',
                                    col2: 'puntopiumahome.it',
                                    col3: '1 giorno',
                                    col4: 'HTTP - Utilizzato da Google Analytics per limitare la frequenza delle richieste',
                                    is_regex: true
                                },

                            ]
                        //         {
                        //             col1: '_gid',
                        //             col2: 'tratti.com',
                        //             col3: '1 giorno',
                        //             col4: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.',
                        //         },
                        //         {
                        //             col1: '_gat',
                        //             col2: 'tratti.com',
                        //             col3: '1 giorno',
                        //             col4: 'HTTP - Utilizzato da Google Analytics per limitare la frequenza delle richieste.',
                        //         },
                        //         {
                        //             col1: 'yt-player-bandwidth',
                        //             col2: 'youtube.com',
                        //             col3: 'Persistente',
                        //             col4: 'HTTP - Utilizzato per determinare la qualità video ottimale in base al dispositivo del visitatore e alle impostazioni di rete.',
                        //         },
                        //         {
                        //             col1: 'yt-player-headers-readable',
                        //             col2: 'youtube.com',
                        //             col3: 'Persistente',
                        //             col4: 'HTML - Utilizzato per determinare la qualità video ottimale in base al dispositivo del visitatore e alle impostazioni di rete.',
                        //         },
                        //
                        //     ],
                        //
                        }, {
                            title: 'Cookie per pubblicità mirata',
                            description: 'Questi cookie possono essere impostati tramite il nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da queste aziende per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti. Non memorizzano direttamente informazioni personali, ma sono basati unicamente sull/individuazione del tuo browser e del tuo dispositivo internet. Se non si accettano questi cookie, riceverai una pubblicità meno mirata.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: '_fbp',
                                    col2: 'puntopiumahome.it',
                                    col3: '3 mesi',
                                    col4: 'HTTP - Utilizzato da Facebook per fornire una serie di prodotti pubblicitari come le offerte in tempo reale di terze parti inserzionisti. ',
                                    domain: "puntopiumahome.it"
                                },
                                {
                                    col1: 'mtc_id',
                                    col2: 'puntopiumahome.it',
                                    col3: 'Sessione',
                                    col4: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                    domain: "puntopiumahome.it"
                                },
                                {
                                    col1: 'mautic_device_id',
                                    col2: 'puntopiumahome.it',
                                    col3: 'Sessione',
                                    col4: "HTTP - Utilizzato per identificare il visitatore attraverso le visite e i dispositivi. Ciò consente al sito web di presentare il visitatore con Pubblicità pertinente - Il servizio è fornito da centri pubblicitari di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti. ",
                                },
                                {
                                    col1: 'mautic_referer_id',
                                    col2: 'puntopiumahome.it',
                                    col3: '1 giorno',
                                    col4: "HTTP - Raccoglie informazioni sul comportamento degli utenti su più siti web. Queste informazioni vengono utilizzate per ottimizzare la pertinenza della pubblicità sul sito web.  ",
                                },
                                {
                                    col1: 'mtc_sid',
                                    col2: 'puntopiumahome.it',
                                    col3: 'Sessione',
                                    col4: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                },
                            ]
                        }, {
                            title: 'Maggiori informazioni',
                            description: 'Per maggiori informazioni consulta l\'informativa sulla  <a href="/privacy-policy" class="cc-link">privacy</a> e sui <a href="/cookie-policy" class="cc-link">cookie</a>.',
                        }
                    ]
                }
            },
            'en': {
                consent_modal: {
                    title: 'Cookies make things better! ',
                    description: 'We use cookies and first or third party identifiers with your consent and / or our legitimate interest, for the purpose of storing or accessing information on your device, to collect personal user data to develop and improve products, as well as to display and measure advertising. ours and / or third parties and / or personalized content based on your navigation (for example the pages you visit).',
                    primary_btn: {
                        text: 'Accept all',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Settings',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept all',
                    reject_all_btn: 'Reject all',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'Cookie options ',
                            description: 'This website uses essential cookies to ensure its proper functioning and tracking cookies to understand how you interact with it. The latter will be set only with prior consent.'
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are necessary for the site to function and cannot be deactivated in our systems. They are usually only set in response to actions you take that constitute a request for services, such as setting your privacy preferences, logging in or filling out forms. You can set your browser to block or have warnings about these cookies, but as a result some parts of the site will not work. These cookies do not store any personal information.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: 'october_session',       // match all cookies starting with "_ga"
                                    col2: 'puntopiumahome.it',
                                    col3: 'Session',
                                    col4: 'HTTP - Preserves visitor session state between page requests.',
                                    is_regex: true
                                },
                            ],
                        }, {
                            title: 'Performance and Analytics cookies',
                            description: 'These cookies allow us to count visits and traffic sources so that we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information collected by cookies is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you have visited our site.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '^_ga',       // match all cookies starting with "_ga"
                                    col2: 'puntopiumahome.it',
                                    col3: '2 years',
                                    col4: 'HTTP - Register a unique ID used to generate statistical data on how the visitor uses the website',
                                    is_regex: true
                                },
                                {
                                    col1: '^_gat',
                                    col2: 'puntopiumahome.it',
                                    col3: '1 day',
                                    col4: 'HTTP - Used by Google Analytics to limit the frequency of requests',
                                },
                                {
                                    col1: '_gid',
                                    col2: 'puntopiumahome.it',
                                    col3: '1 day',
                                    col4: 'HTTP - Register a unique ID used to generate statistical data on how the visitor uses the website.',
                                },
                                // {
                                //     col1: 'collect',
                                //     col2: 'google-analytics.com ',
                                //     col3: '1 day',
                                //     col4: 'Pixel - Used to send data to Google Analytics about the device and user behavior. It tracks the user across devices and marketing channels.',
                                // }
                            ]
                        },{
                            title: 'Advertisement and Targeting cookies',
                            description: 'These cookies may be set through our site by our advertising partners. They can be used by these companies to build a profile of your interests and show you relevant ads on other sites. They do not directly store personal information, but are based solely on the identification of your browser and your internet device. If you do not accept these cookies, you will receive less targeted advertising.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '_fbp',
                                    col2: 'puntopiumahome.it',
                                    col3: '3 months',
                                    col4: 'HTTP - Used by Facebook to deliver a variety of advertising products such as real-time bids from third party advertisers.',
                                    domain: "puntopiumahome.it"
                                },
                                // {
                                //     col1: '^bcookie',       // match all cookies starting with "_ga"
                                //     col2: 'linkedin.com',
                                //     col3: '2 years',
                                //     col4: ' HTTP - used by the service of the LinkedIn social network by tracing the use of the integrated services ',
                                //     is_regex: true
                                // },
                                // {
                                //     col1: '^bscookie',       // match all cookies starting with "_ga"
                                //     col2: 'linkedin.com',
                                //     col3: '2 years',
                                //     col4: ' HTTP - used by the service of the LinkedIn social network by tracing the use of the integrated services ',
                                // },
                                // {
                                //     col1: '^lidc',       // match all cookies starting with "_ga"
                                //     col2: 'linkedin.com',
                                //     col3: 'Persistent',
                                //     col4: ' HTML - HTTP - used by the service of the LinkedIn social network by tracing the use of the integrated services ',
                                // },
                                {
                                    col1: 'mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'puntopiumahome.it',
                                    col3: 'Session',
                                    col4: ' HTTP - Used to identify the visitor across visits and devices. This allows the site to present relevant advertising to the visitor. The service is provided by third-party advertising hubs, which facilitate real-time bidding for advertisers.',
                                    is_regex: true
                                },
                                // {
                                //     col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                //     col2: 'puntopiumahome.it',
                                //     col3: 'Session',
                                //     col4: ' HTTP - Used to identify the visitor across visits and devices. This allows the site to present relevant advertising to the visitor. The service is provided by third-party advertising hubs, which facilitate real-time bidding for advertisers.',
                                // },
                                {
                                    col1: 'mautic_referer_id',       // match all cookies starting with "_ga"
                                    col2: 'puntopiumahome.it',
                                    col3: '1 day',
                                    col4: ' HTTP - Collects information on user behavior on multiple websites. This information is used to optimize the relevance of ati advertising ',
                                },
                                {
                                    col1: 'mtc_id',       // match all cookies starting with "_ga"
                                    col2: 'puntopiumahome.it',
                                    col3: 'Session',
                                    col4: ' HTTP - Used to track visitors across multiple websites in order to present relevant advertisements based on visitor preferences',
                                },
                                // {
                                //     col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                //     col2: 'offcar.mymkt.io',
                                //     col3: 'Session',
                                //     col4: ' HTTP - Used to track visitors across multiple websites in order to present relevant advertisements based on visitor preferences',
                                // },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'puntopiumahome.it',
                                    col3: 'Session',
                                    col4: ' HTTP - Sets a unique ID for the visitor, which allows third-party advertisers to target advertising relevant to the visitor. This matching service is provided by third-party advertising hubs, which facilitate real-time bidding for advertisers.',
                                },
                            ]
                        }, {
                            title: 'More information',
                            description: 'For any queries in relation to our policy on cookies and your choices, please  <a href="/privacy-policy" class="cc-link">privacy</a> and <a href="/cookie-policy" class="cc-link">cookie</a>.',
                        }
                    ]
                }
            }
        }
    });
});
